import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rate-chart-layout',
  templateUrl: './rate-chart-layout.component.html',
  styleUrls: ['./rate-chart-layout.component.css']
})
export class RateChartLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
